/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'extension.charts.aggregateData': 'Daten aggregieren',
  'extension.charts.aggregateDataDescription':
    'Daten werden zu einem einzigen Datenpunkt zusammengefasst, wenn mehrere Zeilen mit demselben Wert vorhanden sind.',
  'extension.charts.category': 'Kategorie',
  'extension.charts.customizeTab': 'Anpassen',
  'extension.charts.dataMissing.details': 'Die Quelltabelle dieses Diagramms wurde nicht auf der Seite gefunden.',
  'extension.charts.dataMissing.title': 'Keine anzuzeigenden Daten',
  'extension.charts.dataTab': 'Daten',
  'extension.charts.defaultColumnName': 'Spalte {0}',
  'extension.charts.defaultTitle': 'Unbenanntes Diagramm',
  'extension.charts.defaultYLabel': 'Unbenannte Achse',
  'extension.charts.extensionTitle': 'Diagramm',
  'extension.charts.height': 'Höhe der Grundfläche',
  'extension.charts.height.large': 'Größer',
  'extension.charts.height.medium': 'Standard',
  'extension.charts.height.small': 'Kleiner',
  'extension.charts.horizontal.orientation.label': 'Horizontal',
  'extension.charts.insert.tooltip': 'Diagramm einfügen',
  'extension.charts.legend': 'Legende',
  'extension.charts.legend.auto': 'Auto',
  'extension.charts.legend.bottom': 'Unten',
  'extension.charts.legend.left': 'Links',
  'extension.charts.legend.position': 'Position der Legende',
  'extension.charts.legend.right': 'Rechts',
  'extension.charts.legend.show': 'Legende anzeigen',
  'extension.charts.legend.top': 'Oben',
  'extension.charts.options.label': 'Diagrammoptionen',
  'extension.charts.options.tooltip': 'Diagrammoptionen ändern',
  'extension.charts.orientation.label': 'Ausrichtung',
  'extension.charts.seriesNames': 'Datenreihe',
  'extension.charts.showPoints': 'Datenpunkte anzeigen',
  'extension.charts.smoothLines': 'Glatte Linien',
  'extension.charts.style': 'Stil',
  'extension.charts.title': 'Titel',
  'extension.charts.type.bar': 'Balken',
  'extension.charts.type.fieldDescription': 'Diagrammtyp',
  'extension.charts.type.line': 'Linien',
  'extension.charts.type.pie': 'Torte',
  'extension.charts.userTitle': 'Titel',
  'extension.charts.vertical.orientation.label': 'Vertikal',
  'extension.charts.xAxis': 'x-Achse',
  'extension.charts.xLabel': 'Label x-Achse',
  'extension.charts.yLabel': 'Label y-Achse',
};
